import { MsalGuardConfiguration, MsalInterceptorConfiguration } from "@azure/msal-angular";
import { BrowserCacheLocation, IPublicClientApplication, InteractionType, LogLevel, PublicClientApplication } from "@azure/msal-browser";
import { environment } from "src/environments/environment";

const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

/* export function loggerCallback(logLevel: LogLevel, message: string) {
  
  console.log(message);
  console.log(logLevel);
} */

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({

    auth: {
      clientId: environment.prescriptionsService.clientId,
      authority: environment.prescriptionsService.authority,
      redirectUri: environment.prescriptionsService.redirectUri,
      postLogoutRedirectUri: environment.prescriptionsService.logoutRedirectUri
    },

    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE,
    },
    
    system: {
      allowNativeBroker: false,
      allowRedirectInIframe: true,
      loggerOptions: {
        // loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false
      }
    }
  });
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: environment.prescriptionsService.scopes
    }
  };
}

export function UsersMSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: environment.usersService.scopes
    }
  };
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  
  protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['user.read']);
  protectedResourceMap.set(environment.prescriptionsService.url , environment.prescriptionsService.scopes);//prescriptions Config
  protectedResourceMap.set(environment.usersService.url , environment.usersService.scopes);//users Config
  protectedResourceMap.set(environment.patientsService.url , environment.patientsService.scopes);//patients Config
  protectedResourceMap.set(environment.masterDataService.url , environment.masterDataService.scopes);//masterData Config
  
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}